import RequestState from 'Enums/RequestState'
/**
 * The initial values for the redux state.
 */
export const INITIAL_STATE = {
  chargingTokenDesigns: [],
  allChargingTokenDesigns: [],
  fetchChargingTokenDesignsRequestState: RequestState.UNINITIALIZED,
  fetchAllChargingTokenDesignsRequestState: RequestState.UNINITIALIZED,
  addChargingTokenDesignRequestState: RequestState.UNINITIALIZED,
  editChargingTokenDesignRequestState: RequestState.UNINITIALIZED,
  getChargingTokenCountRequestState: RequestState.UNINITIALIZED,
  deleteChargingTokenDesignRequestState: RequestState.UNINITIALIZED,
  paginationOffset: 0,
  count: 0,
}
